<div class="flex justify-center items-center">
  @if (isLoading) {
    <div class="flex space-x-1">
      <div class="h-3 w-3 bg-yellow-500 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
      <div class="h-3 w-3 bg-yellow-500 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
      <div class="h-3 w-3 bg-yellow-500 rounded-full animate-bounce"></div>
    </div>
  }
</div>